import { getLocalizedString } from "@grandvisionhq/utils";
import { toBaseLineItem } from "./base-line-item.js";
import { getLineItemImageUrl } from "../../../../../../utils/utils/get-line-item-image-url.js";
import { getProductTitle } from "../../../utils/mappers/view/visual-line-item/utils/get-product-title.js";
import { getAttribute } from "../../../../../../utils/utils/get-line-item-attribute.js";
import { getLineItemAvailability } from "../../../../../../utils/utils/get-line-item-availability.js";
import { getProductA11yLabel } from "../../../utils/mappers/view/visual-line-item/utils/get-product-a11y-label.js";
const toRegularCartLineItem = (cartLineItem, intl, settings) => {
  const imageUrl = getLineItemImageUrl(cartLineItem.legacyProduct.masterData.current.variant);
  const base = toBaseLineItem(cartLineItem, settings, intl);
  const variant = cartLineItem.legacyProduct.masterData.current.variant;
  let title = getProductTitle(cartLineItem.legacyProduct, intl);
  let subtitle = "";
  switch (cartLineItem.legacyProduct.productType.toLowerCase()) {
    case "solutions":
      title = getLocalizedString(cartLineItem.legacyProduct.masterData.current.name, intl.locale);
      subtitle = `${getAttribute(variant, "solutionType")}, ${getAttribute(variant, "volume")}${getAttribute(variant, "volumeUnit") || "ml"}`;
      break;
    case "frames":
      subtitle = `${getAttribute(variant, "brandModelCode")}, ${intl.getLabel(
        "products.frames.frameOnly.description"
      )}`;
      break;
    case "ready-readers":
      subtitle = `${intl.getLabel("products.readyreaders.power")}: ${getAttribute(
        variant,
        "power"
      )}`;
      break;
    case "sunglasses":
    case "accessories":
      subtitle = getAttribute(variant, "brandModel");
      break;
  }
  return {
    ...base,
    imageUrl,
    subtitle,
    title,
    altText: getProductA11yLabel(cartLineItem, intl),
    sku: cartLineItem.sku,
    type: "REGULAR",
    ...variant.availability ? { availability: getLineItemAvailability(variant.availability) } : {}
  };
};
export {
  toRegularCartLineItem
};
//# sourceMappingURL=regular-line-item.js.map
